export default __webpack_public_path__ + "static/media/_00012_deposito.efa080f4.png";